/**
 * ライトのままの区画（#191 の2回目、docs/77 §8）：ダークの画面の中でも、紙・地図をライトのまま描く。
 *   <div data-mode="light" data-theme="{今のテーマ}">（display:contents＝並びは変えない）。styles.css の [data-mode="light"] と [data-theme] が
 *   この中だけ変数をライトに戻す。使う所＝作成画面の「できあがりの紙」・地図。画面ごと（紙の画面・帳票デザインのエディタ）は lib/theme.ts の isLightOnlyPath
 */
import { useSyncExternalStore, type ReactNode } from "react";
import { PRODUCTS, type Product } from "@genbaryoku/contract";
import { currentMode, currentTheme, subscribeMode, subscribeTheme } from "../lib/theme.js";

export function LightArea({ children }: { children: ReactNode }) {
  const theme = useSyncExternalStore(subscribeTheme, currentTheme, currentTheme);
  return (
    <div className="lightarea" data-mode="light" data-theme={theme}>
      {children}
    </div>
  );
}

/** いま当たっている明るさ（<html data-mode>） */
export function useColorModeNow() {
  return useSyncExternalStore(subscribeMode, currentMode, currentMode);
}

/** 上の帯のロゴ（横組み・ローマ字なし）。ダークでは題字が白の暗い地用（docs/77 §8） */
export function useLogoHeader(product: Product): string {
  const mode = useColorModeNow();
  const a = PRODUCTS[product].assets;
  return mode === "dark" ? a.logoHeaderDark : a.logoHeader;
}
